import { StyledText } from '../../atoms/Text/StyledText';
import PaymentsPopup from '../Payments/PaymentsPopup';
import { StyledButtonsWrapper } from '../../atoms/Payments/StyledButtonsWrapper';
import { StyledButton } from '../../atoms/Button/StyledButton';
import { StyledUPopupCloseButton } from '../../atoms/Payments/StyledUPopupCloseButton';

const MarkHourAsPaidConfirmPopup = ({
    confirmPopup,
    setConfirmPopup,
    handleAcceptHour,
    student,
    hours_count,
    date,
    subject,
    getString,
}) => {
    if (!confirmPopup) return null;
    return (
        <PaymentsPopup
            title={
                getString('student_payments_element_are_you_sure') +
                ` Szczegóły: ${student} ${hours_count}h ${date} ${subject}`
            }
            onClose={handleAcceptHour}
            cancelTag={getString('student_payments_element_cancel')}
            closeTag={getString('student_payments_element_yes')}
            onCancel={() => setConfirmPopup(false)}
        >
            <div
                style={{
                    widht: '100%',
                    height: '100%',
                    paddingBottom: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    flex: 1,
                }}
            >
                <StyledText
                    hasdeclaredfontsize="18px"
                    hasdeclaredpadding="50px 20px 0px 20px"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredtextalign="center"
                >
                    {getString('student_payments_element_are_you_sure')}
                </StyledText>
                <StyledText
                    hasdeclaredfontsize="18px"
                    hasdeclaredpadding="20px 20px 50px 20px"
                    hasdeclaredlineheight="1.4em"
                    hasdeclaredtextalign="center"
                >
                    Szczegóły: {student} {hours_count}h {date} {subject}
                </StyledText>
                <StyledButtonsWrapper>
                    <StyledButton onClick={() => setConfirmPopup(false)}>
                        {getString('student_payments_element_cancel')}
                    </StyledButton>
                    <StyledUPopupCloseButton onClick={handleAcceptHour}>
                        <StyledText
                            hasdeclaredfontsize="18px"
                            hasdeclaredtextalign="center"
                            hasdeclaredfontweight="700"
                            hasdeclaredfontcolor="#fff"
                            hascursor="pointer"
                        >
                            {getString('student_payments_element_yes')}
                        </StyledText>
                    </StyledUPopupCloseButton>
                </StyledButtonsWrapper>
            </div>
        </PaymentsPopup>
    );
};

export default MarkHourAsPaidConfirmPopup;
